import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getCurrentUser, restoreSession, getAccessControl } from '@store/slices/authSlice';
import LogoLoader from './LogoLoader';

const PrivateRoute = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, hasSession, user, accessControl, loading, sessionRestoring } = useAppSelector((state) => state.auth);
  const [sessionChecked, setSessionChecked] = useState(false);

  // Try to restore session if user has a stored refresh token but no access token
  useEffect(() => {
    const tryRestoreSession = async () => {
      if (!isAuthenticated && hasSession && !sessionRestoring && !sessionChecked) {
        await dispatch(restoreSession());
      }
      setSessionChecked(true);
    };

    tryRestoreSession();
  }, [isAuthenticated, hasSession, sessionRestoring, sessionChecked, dispatch]);

  // Fetch user data once authenticated
  useEffect(() => {
    if (isAuthenticated && !user && !loading) {
      dispatch(getCurrentUser());
    }
  }, [isAuthenticated, user, loading, dispatch]);

  // Fetch access control permissions once authenticated
  // This runs only once when the component mounts and user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getAccessControl());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, dispatch]);

  // Show loading while restoring session or loading user
  if (sessionRestoring || (hasSession && !sessionChecked)) {
    return <LogoLoader message="Restoring session" />;
  }

  if (loading) {
    return <LogoLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
